import { Link } from 'react-router-dom';
import { Box, Button, Container, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import {
  IconArrowRight,
  IconGitFork,
  IconMessageCircle,
  IconShieldCheckFilled,
} from '@tabler/icons-react';

import { Reveal } from '@/components/motion/Reveal';
import classes from './Community.module.css';

const STATS = [
  { Icon: IconShieldCheckFilled, value: 'Verdict', label: 'On every shared tune' },
  { Icon: IconGitFork, value: 'Fork', label: 'Build on what works' },
  { Icon: IconMessageCircle, value: 'Forums', label: 'Per platform & topic' },
] as const;

export function Community() {
  return (
    <Box component="section" id="community" py={{ base: 64, md: 96 }} aria-labelledby="community-title">
      <Container size="lg">
        <Box className={classes.card}>
          <Stack align="center" ta="center" gap="md">
            <Reveal>
              <Text size="sm" tt="uppercase" lts="0.12em" c="var(--tf-forge-start)" fw={700}>
                Community
              </Text>
            </Reveal>
            <Reveal delay={0.05}>
              <Title id="community-title" order={2} className={classes.heading}>
                Join the Clancy Tuning community.
              </Title>
            </Reveal>
            <Reveal delay={0.1}>
              <Text c="var(--tf-text-secondary)" maw={560}>
                Launching with a community library, per-platform forums, and a fork/remix workflow
                — all with the same deterministic safety verdicts attached. Be one of the first
                tuners to publish.
              </Text>
            </Reveal>

            <Reveal delay={0.15}>
              <SimpleGrid cols={{ base: 3 }} spacing={{ base: 'lg', sm: 'xl' }} mt="md">
                {STATS.map((s) => {
                  const Icon = s.Icon;
                  return (
                    <Stack key={s.label} gap={4} align="center">
                      <Box className={classes.statIcon} aria-hidden="true">
                        <Icon size={20} stroke={1.8} />
                      </Box>
                      <Text className={classes.statValue}>{s.value}</Text>
                      <Text size="xs" tt="uppercase" lts="0.06em" c="var(--tf-text-muted)">
                        {s.label}
                      </Text>
                    </Stack>
                  );
                })}
              </SimpleGrid>
            </Reveal>

            <Reveal delay={0.25}>
              <Group gap="sm" mt="lg" wrap="wrap" justify="center">
                <Button
                  component={Link}
                  to="/community/tunes"
                  size="md"
                  radius="md"
                  variant="gradient"
                  gradient={{ from: 'var(--tf-forge-start)', to: 'var(--tf-forge-end)', deg: 135 }}
                  rightSection={<IconArrowRight size={16} />}
                >
                  Browse the tune library
                </Button>
                <Button component={Link} to="/community" size="md" radius="md" variant="default">
                  Visit the forums
                </Button>
              </Group>
            </Reveal>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
